import { Shell } from "../app/Shell";
import { ExportPanel } from "./ExportPanel";
import { ImportPanel } from "./ImportPanel";
import "./bulk.css";

/**
 * Bulk Products: many products at once, through the one product domain.
 *
 * WHAT THIS SCREEN IS NOT. It is not a catalogue editor and it is not a
 * spreadsheet. The workbook is the editing surface — an operator already has a
 * tool for that and it is better than anything that could be rebuilt here — so
 * this screen validates, previews, confirms and reports, and does nothing that
 * would give a product two places to be edited.
 *
 * Export and import are one workflow shown as two areas, in the order they are
 * used: most bulk edits begin by downloading what is already there.
 *
 * Nothing here creates a product a different way. Every row goes through the
 * same services Product Management uses, ends as a normal draft, and is
 * published — if it is published at all — through the gate that validates it.
 *
 * AND IT DOES NOT PHOTOGRAPH ANYTHING. The workbook carries catalogue data.
 * Photographs belong to the product they are of and are chosen on its own Edit
 * screen, per variant, in that family's own vocabulary — which is where an
 * operator can see what they are attaching to what.
 */
export function BulkProductsPage() {
  return (
    <Shell title="Bulk Products">
      <div className="stack bulk">
        <p className="muted bulk__intro">
          Edit many products in one workbook. Download what is already in the
          catalogue, change it, and check it here before anything is applied.
          Stock is never changed by an import — quantities move in Inventory,
          which records why. Photographs are added to each product on its own
          page, after it is imported.
        </p>
        <ExportPanel />
        <ImportPanel />
      </div>
    </Shell>
  );
}
